import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CancelOrderModal.css';

const CancelOrderModal = ({ show, orderNumber, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) setMessage('');
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (message || '').trim();
    if (!trimmed) return;
    setSubmitting(true);
    try {
      await onConfirm(trimmed);
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className="cancel-order-modal-overlay" onClick={onClose} role="dialog" aria-labelledby="cancel-order-modal-title">
      <div className="cancel-order-modal" onClick={e => e.stopPropagation()}>
        <h3 id="cancel-order-modal-title">{t('cancelOrderModal.title')}</h3>
        <p className="cancel-order-modal-hint">{t('cancelOrderModal.hint')}</p>
        {orderNumber && (
          <p className="cancel-order-modal-order">#{orderNumber}</p>
        )}
        <form onSubmit={handleSubmit}>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder={t('cancelOrderModal.placeholder')}
            className="cancel-order-modal-textarea"
            rows={4}
            required
            autoFocus
            disabled={submitting}
          />
          <div className="cancel-order-modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              {t('cancelOrderModal.cancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={submitting || !message.trim()}>
              {submitting ? t('cancelOrderModal.submitting') : t('cancelOrderModal.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelOrderModal;
